import { PRIZES } from '../../content/site';
import { CellGrid } from './CellGrid';

/**
 * Live/post product showcase — the same 6-cell neon frame as the heroes
 * grid, per the dev frame: product photography only, no name labels and
 * NO traveling diamonds. Product names feed the images' alt text.
 * `priority`: this grid leads the band right below the hero in LIVE/POST,
 * so its photos fetch at high priority.
 */
export function ProductsGrid() {
  return <CellGrid cells={PRIZES} priority />;
}
